import { Map } from 'immutable'

import { get as getConfig } from '../../config/index'

export function isCheckoutDiscountCodesEnabled () {
  return !!getConfig().features?.checkout?.discountCodes
}

/**
 * Discount code to send on checkout order submission.
 * Requires the feature flag, a stored code, and eligible discount response.
 * @param {import('immutable').Map} checkoutState
 * @returns {string|undefined}
 */
export function getCheckoutOrderDiscountCode (checkoutState) {
  if (!isCheckoutDiscountCodesEnabled()) {
    return undefined
  }

  if (!Map.isMap(checkoutState)) {
    return undefined
  }

  const discountCode = checkoutState.get('discountCode')
  if (!discountCode) {
    return undefined
  }

  const discountEligibility = checkoutState.get('discountEligibility')
  if (!Map.isMap(discountEligibility) || discountEligibility.get('eligible') !== true) {
    return undefined
  }

  return discountCode
}
